<template>
  <div>
    <a-card style="width: 100%; margin-bottom: 20px;">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="12">
            <a-col :md="5" :sm="12">
              <a-form-item label="管类选择">
                <a-cascader :options="options" :display-render="displayRender" expand-trigger="hover"
                  placeholder="请选择管类" @change="handleChange" />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="12" style="display: flex">
              <a-button type="primary" style="margin-left: 12px" @click="elementSetting()">要素设置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>

    <a-card style="width: 100%; " v-show="elementSettingCard">
      <a-spin :spinning="spinning">
        <div class="titleName">
          <span>{{ titleText }}</span>
          <div style="margin-left: 25px;" v-if="titleText && titleText.indexOf('管点口径') > -1">
            <a-radio-group v-model="caliberType">
              <a-radio :value="1">口径</a-radio>
              <a-radio :value="2">异径</a-radio>
            </a-radio-group>
          </div>
        </div>
        <div style="margin-bottom: 10px;">
          <a-row :gutter="12">
            <a-col :md="5" :sm="12" style="display: flex">
              <a-button type="primary" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()" v-action:del>删除</a-button>
            </a-col>
          </a-row>
        </div>

        <a-table ref="table" :columns="columns" :data-source="propertyList" bordered :pagination="false"
          :scroll="{ y: 510 }" :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
          :rowKey="(record, index) => record.id"
          :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)">

          <span slot="reveal" slot-scope="text, record">
            <!-- <a-switch :checked="(record.ifOpen == 0) ? true : false" @change="onRevealChangeUpdate(record)" /> -->
              {{ record.ifOpen == 0 ? '是' : '否'}}
          </span>
          <span slot="action" slot-scope="text, record">
            <a style="margin-left: 15px;" @click="Handle(record)" v-action:edit>编辑</a>
          </span>
        </a-table>



        <a-modal :title="isUpdate ? '编辑' : '新增'" width="50%" v-model="addOrUpdateVisible">
          <a-form :form="addOrUpdateForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
            <a-form-item label="要素名称">
              <a-input placeholder="请输入要素名称"
                v-decorator="['elementName', { rules: [{ required: true, message: '请输入要素名称' }] }]" />
            </a-form-item>
            <a-form-item label="排序值">
              <a-input placeholder="请输入排序值"
                v-decorator="['sortValues', { rules: [{ required: true, message: '请输入排序值' }] }]" />
            </a-form-item>
            <a-form-item label="是否显示">
              <a-switch @change="onRevealChangeIfOpen" v-decorator="['ifOpen', { valuePropName: 'checked' }]" />
            </a-form-item>
          </a-form>
          <div slot="footer">
            <a-button @click="handleCancel">取消</a-button>
            <a-button type="primary" @click="handleOk" >确定</a-button>
          </div>
        </a-modal>
      </a-spin>
    </a-card>

  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { Cascader as ACascader } from 'ant-design-vue';

const columns = [
  {
    title: '排序编号',
    dataIndex: 'sortValues'
  },
  {
    title: '要素名称',
    dataIndex: 'elementName'

  },
  {
    title: '是否显示',
    dataIndex: 'ifOpen',
    scopedSlots: { customRender: 'reveal' }
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: 200,
    scopedSlots: { customRender: 'action' }
  }
]

const list = [];
export default {
  components: {
    'a-cascader': ACascader,
  },
  mixins: [mixinViewModule],
  name: 'ElementSetting',
  data () {
    return {
      list,
      columns,
      needPage: false,
      needQuery: false, // 是否在created就执行查询操作
      spinning: false,
      queryUrl: '/gis-manager/foundation/element/list',

      queryListUrl: '/gis-manager/foundation/element/list',
      addUrl: '/gis-manager/foundation/element/add',
      updateUrl: '/gis-manager/foundation/element/edit',
      queryOneUrl: '/gis-manager/foundation/element/get',
      deleteUrl: '/gis-manager/foundation/element/remove',
      pLId: '',
      options: [],
      updataId: '',
      propertyList: [],
      ifOpen: '1',
      titleText: '',
      elementSettingCard: false,
      query: {
        ruleName: '',
        tenantId: this.$store.state.user.info.tenantId
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      caliberType: 1,
      selectedOptions: []
    }
  },
  computed: {

  },
  watch: {
    list (newVal, oldVal) {
      this.getOptions()
    },
    caliberType (newVal, oldVal) {
      //口径
      if (newVal == 1) {
        this.queryListUrl = '/gis-manager/foundation/element/list'
        this.addUrl = '/gis-manager/foundation/element/add'
        this.updateUrl = '/gis-manager/foundation/element/edit'
        this.queryOneUrl = '/gis-manager/foundation/element/get'
        this.deleteUrl = '/gis-manager/foundation/element/remove'

      } else {
        //异径
        this.queryListUrl = '/gis-manager/foundation/different/list'
        this.addUrl = '/gis-manager/foundation/different/add'
        this.updateUrl = '/gis-manager/foundation/different/update'
        this.queryOneUrl = '/gis-manager/foundation/different/get'
        this.deleteUrl = '/gis-manager/foundation/different/remove '
      }
      this.getElementList()

    },
  },
  created () {
    this.queryList()
  },
  methods: {
    resetList () {
      this.updataId = ''
      this.getElementList()
    },
    getOptions () {
      let optionToList = this.list;
      for (let i = 0; i < optionToList.length; i++) {
        let option = {};
        option.value = optionToList[i].id;
        option.label = optionToList[i].tubeClassName + '(' + optionToList[i].tubeClassCode + ')';
        option.tubeClassId = optionToList[i].tubeClassId
        option.tubeClassCode = optionToList[i].tubeClassCode
        option.tubeClassName = optionToList[i].tubeClassName

        for (let t = 0; t < optionToList[i].propertiesSettingChildList.length; t++) {
          if (t == 0) {
            option.children = [];
          }
          option.children.push({
            value: optionToList[i].propertiesSettingChildList[t].id,
            label: optionToList[i].tubeClassName + optionToList[i].propertiesSettingChildList[t].attributeName + '(' + optionToList[i].tubeClassCode + ')',

          })
        }
        this.options.push(option);
      }
    },
    displayRender ({ labels, selectedOptions }) {
      this.selectedOptions = selectedOptions
      console.log(selectedOptions);
      this.titleText = labels[labels.length - 1];
      return this.titleText;
    },
    onRevealChange (item) {
      console.log(item)
    },
    onRevealChangeIfOpen (e) {
      if (e) {
        this.ifOpen = '0'
      } else {
        this.ifOpen = '1'
      }
    },
    addOrUpdateHandle (id) {
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      if (id) {
        this.isUpdate = true
        this.$http.get(`${this.queryOneUrl}/${this.currentId}`).then(({
          data
        }) => {
          this.ifOpen = data.ifOpen
          if (data.ifOpen == '0') {
            data.ifOpen = true
          } else {
            data.ifOpen = false
          }
          this.addOrUpdateForm.setFieldsValue({
            sortValues: data.sortValues,
            elementName: data.elementName,
            ifOpen: data.ifOpen
          })
        }).catch(() => { })
      }
    },
    handleCancel (e) {
      this.addOrUpdateVisible = false
    },
    Handle (record) {
      this.updataId = record.id
      this.addOrUpdateHandle(record.id)
      this.showModal()
    },
    showModal () {
      this.visible = true
    },
    handleChange (value) {
      this.pLId = value[value.length - 1];
    },
    onRevealChangeUpdate (e) {
      if (e.ifOpen == '0') {
        e.ifOpen = '1'
      } else {
        e.ifOpen = '0'
      }
      this.$http.post(this.updateUrl, e).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.message)
          this.resetList()
        } else {
          this.$message.error('修改失败')
        }
      })
    },
    elementSetting () {
      if (this.pLId == '' || this.pLId == undefined) {
        this.$message.warning('请选择一个要素进行配置')
      } else {
        this.getElementList()

      }
    },
    getElementList () {
      this.spinning = true;
      let id = ''
      if (this.caliberType == 1) {
        id = this.pLId
      } else {
        id = this.selectedOptions[0].tubeClassId

      }
      this.$http.get(this.queryListUrl + '/' + id).then(res => {
        if (res.code == 0) {
          this.elementSettingCard = true;
          this.propertyList = res.data
         // this.$message.success('查询管类要素成功')
        } else {
          this.$message.error('查询失败')
        }
      }).finally(() => {
        setTimeout(() => {
          this.spinning = false;
        }, 500);
      })

    },
    deleteSelectRow () {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }
      const _this = this
      const selectedCount = this.selectedRows.length
      const selectedIds = this.selectedRows.map(str => parseInt(str, 10))
      console.log(selectedIds, _this.deleteUrl)
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除选择的${selectedCount}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          _this.$http.post(_this.deleteUrl,
            selectedIds
          ).then((res) => {
            if (res.code === 0) {
              _this.$message.success(`共删除${selectedCount}条数据`)
              _this.selectedRows = []
              _this.resetList()
              _this.queryList()
            }
          }).catch(() => { })
        },
        onCancel () {
          _this.$message.info('已取消删除')
        }
      })
    },
    handleOk () {
      this.addOrUpdateForm.validateFields((err, values) => {
        let addOrUpdataUrl = this.addUrl
        if (this.updataId != '') {
          addOrUpdataUrl = this.updateUrl
          values.id = this.updataId
        }
        values.propertiesSettingChildId = this.pLId
        values.ifOpen = this.ifOpen
        //异径
        if (this.caliberType == 2) {
          values.tubeClassId = this.selectedOptions[0].tubeClassId
          values.tubeClassCode = this.selectedOptions[0].tubeClassCode
          values.tubeClassName = this.selectedOptions[0].tubeClassName
        }
        console.log('handleOk', values);
        if (!err) {
          this.$http.post(addOrUpdataUrl, values).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.message)
              this.addOrUpdateVisible = false
              this.updataId = ''
              this.resetList()
            } else {
              this.$message.error('操作失败')
            }
          })
        }
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  }
}
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  height: 99vh;
  // border: 1px solid red;
}

.titleName {
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  span {
    font-size: 16px;
    color: #333333;
    line-height: 22px;
  }

}

.search {
  width: 100%;
  height: 40px;
  // border: 1px solid red;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

/deep/.table-striped {
  background-color: #fafafa;
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>